const ERROR_MESSAGE_TITLE = 'authentication.message.error';
const ACTIVATION_CODE_ERROR = 'authentication.send.error';

export class VerificationContainerController {
    /* @ngInject */
    constructor(passwordCredentialsService,
                contactPointService,
                destinationService,
                userSessionService,
                accountCreationHelpService,
                toastr,
                $translate,
                $state,
                $stateParams,
                $log) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.contactPointService = contactPointService;
        this.destinationService = destinationService;
        this.userSessionService = userSessionService;
        this.accountCreationHelpService = accountCreationHelpService;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$log = $log;
    }

    $onInit() {
        this.user = {};
        this.verifyUserSession();

        this.emailType = 'EMAIL';

        this.emailVerificationAction = 'VERIFY_EMAIL';
        this.twoFactorEnabled = this.destinationOrganization.securityConfiguration.twoFactorEnabled;

        this.edit = this.$stateParams.state === 'EDIT';

        this.toastr.options = {
            "showDuration": "6000"
        };

        this.$translate([
            ERROR_MESSAGE_TITLE,
            ACTIVATION_CODE_ERROR
        ]).then(translations => this.translations = translations)
            .catch(error => this.$log.error(error));
    }

    verifyUserSession() {
        if (this.userSessions.length == 1) {
            this.user = this.userSessions[0];
        }
    }

    verifyActivationCode() {
        if (this.$stateParams.state === 'ACTIVATE') {
            this.verifyContactPoint();
        }

        if (this.$stateParams.state === 'EDIT') {
            this.verifyContactPoint();
            this.$state.go('flow');
        }
    }

    verifyContactPoint() {
        this.contactPointService.verifyContactPoint(this.emailVerificationAction, this.$stateParams.email, this.verificationCode)
            .then(() => {
                this.toastr.success(this.generateContactPointVerificationSuccessMessage(), 'Success');
                if (this.$stateParams.state === 'ACTIVATE') {
                    this.accountCreationHelpService.handleActivationNavigation(this.twoFactorEnabled, this.$stateParams.username, this.user, this.$stateParams.email);
                }
            })
            .catch(() => this.toastr.error(this.translations[ACTIVATION_CODE_ERROR], this.translations[ERROR_MESSAGE_TITLE]));
    }

    generateContactPointVerificationSuccessMessage() {
        let i = this.emailType.indexOf('_');
        this.emailType = this.emailType.substring(this.emailType.length, i !== -1 ? i + 1 : 0);
        let verifyContactPointSuccessMessage =
            this.emailType.toLowerCase().charAt(0).toUpperCase() +
            this.emailType.toLocaleLowerCase().slice(1) +
            ' er blevet aktiveret';
        return verifyContactPointSuccessMessage;
    }

    backToEmailSelection() {
        this.$state.go('activate.email', {
            state: this.$stateParams.state,
            popup: this.$stateParams.popup,
            username: this.$stateParams.username
        });
    }
}

export let VerificationContainerComponent = {
    controller: VerificationContainerController,
    controllerAs: 'vm',
    templateUrl: 'app/login/verification/VerificationContainerComponent.html',
    bindings: {
        destinationOrganization: '<',
        userSessions: '<'
    }
};
